import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import { uniqueId } from 'lodash';

/**
 * @description 给菜单数据补充上 path 字段
 * @description https://github.com/d2-projects/d2-admin/issues/209
 * @param {Array} menu 原始的菜单数据
 */
function supplementPath(menu) {
  return menu.map(function (e) {
    return _objectSpread(_objectSpread({}, e), {}, {
      path: e.path || uniqueId('d2-menu-empty-')
    }, e.children ? {
      children: supplementPath(e.children)
    } : {});
  });
}

// 菜单 侧边栏
export var menuAside = supplementPath([{
  path: '/index',
  title: '首页',
  icon: 'shouye'
}, {
  title: '函证',
  icon: 'xiangmu',
  children: [{
    path: '/correspondence/task',
    meta: {
      permission: 'isGroup'
    },
    title: '作业管控',
    icon: '-shengchanzuoye'
  }, {
    path: '/correspondence/object',
    title: '发函对象',
    meta: {
      permission: 'isGroup'
    },
    icon: 'shouhuodizhi'
  }, {
    path: '/correspondence/interactive',
    meta: {
      hx: true
    },
    title: '发函交互',
    icon: 'lianjie'
  }, {
    path: '/correspondence/batch',
    title: '统一发函',
    meta: {
      permission: 'sender'
    },
    icon: 'shouhuodizhi'
  }, {
    path: '/correspondence/reject',
    title: '统一已回置已发',
    meta: {
      permission: 'cpsccAdmin'
    },
    icon: 'shouhuodizhi'
  }, {
    path: '/correspondence/send',
    title: '函证管控',
    meta: {
      permission: 'cpscc'
    },
    icon: 'kongjianguankong_guankongdanyuan'
  }, {
    path: '/correspondence/send-history',
    meta: {
      permission: 'cpscc'
    },
    title: '已归档函证',
    icon: 'kongjianguankong_guankongdanyuan'
  },
  // {
  //   path: '/correspondence/distribute',
  //   title: '统一分发',
  //   meta: {
  //     permission: 'cpscc'
  //   },
  //   icon: 'kongjianguankong_guankongdanyuan'
  // },
  // { path: '/correspondence/reminder', title: '催函管理' },
  // { path: '/correspondence/reply', title: '回函管理' },
  {
    path: '/correspondence/control-list',
    meta: {
      permission: 'isGroup'
    },
    title: '函证控制表',
    icon: 'biaogebuju'
  }]
},
// {
//   title: '统计',
//   icon: 'folder-o',
//   children: [
//     { path: '/statistics/correspondence', title: '函证统计' },
//     { path: '/statistics/cost', title: '费用统计' },
//     { path: '/statistics/workload', title: '工作量统计' },
//   ]
// },
{
  title: '模板',
  icon: 'moban',
  children: [{
    path: '/template',
    title: '模板管控',
    meta: {
      permission: 'Task_Template'
    },
    icon: 'mobanguanli'
  }]
}, {
  title: '配置',
  icon: 'peizhiguanli',
  children: [{
    path: '/setting/tenant',
    title: '租户信息',
    meta: {
      permission: 'admin'
    },
    icon: 'zuhuguanli'
  },
  // { path: '/setting/correspondence', title: '函证中心设置' },
  {
    path: '/setting/organization',
    title: '组织架构',
    meta: {
      permission: 'Setting_TenatStruct'
    },
    icon: 'zuzhijiagou'
  }, {
    path: '/setting/business',
    title: '作业类型',
    meta: {
      permission: 'Setting_BusinessType'
    },
    icon: 'leixing'
  }, {
    path: '/setting/user',
    title: '用户管理',
    meta: {
      permission: 'Setting_UserManger'
    },
    icon: 'yonghuguanli_huaban'
  }, {
    path: '/setting/task',
    title: '作业授权',
    meta: {
      permission: 'admin'
    },
    icon: 'shouquan'
  }, {
    path: '/setting/modular',
    title: '模块配置',
    meta: {
      permission: 'admin'
    },
    icon: 'yingyongmokuai'
  },
  // { path: '/setting/template', title: '函证模板' },
  {
    path: '/setting/third-party',
    title: '智能第三方',
    meta: {
      permission: 'admin'
    },
    icon: 'disanfangdanbao'
  },
  // {
  //   path: '/setting/risk',
  //   title: '风险参数',
  //   meta: {
  //     permission: 'admin'
  //   },
  //   icon: 'fengxian',
  // },
  {
    path: '/setting/dictionary',
    title: '数据字典',
    meta: {
      permission: 'admin'
    },
    icon: 'shujuzidian'
  }]
}]);

// 菜单 顶栏
export var menuHeader = supplementPath([]);